import * as React from "react";
import { useReducer, useEffect } from "react";
import fetchAPI from "../utils/fetchAPI";
import { useSettingsContext } from "./settings";

const initialState = {
    tax: {},
    selectedTax: {},
}

const actions = {
    SET_TAX_OPTIONS: "SET_TAX_OPTIONS",
    SELECT_TAX_TERM: "SELECT_TAX_TERM",
    CLEAR_FILTERS: "CLEAR_FILTERS",
}

const reducer = (state, action) => {
    switch (action.type) {
        case actions.SET_TAX_OPTIONS : {
            return {
                ...state,
                tax: action.payload
            }
        }

        case actions.SELECT_TAX_TERM : {
            let selectedTax = { ...state.selectedTax };
            if ( action.payload.term !== '' ) {
                selectedTax[ action.payload.tax ] = action.payload.term;
            } else if ( 'undefined' !== typeof selectedTax[ action.payload.tax ] ) {
                delete selectedTax[ action.payload.tax ];
            }

            return {
                ...state,
                selectedTax: selectedTax,
            };
        }

        case actions.CLEAR_FILTERS : {
            return {
                ...state,
                selectedTax: {},
            };
        }

        default: {
            return state;
        }
    }
}

const FiltersContext = React.createContext();

const FiltersProvider = ({ children }) => {
    const [ state, dispatch ] = useReducer( reducer, initialState );
    const settings = useSettingsContext();

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetchAPI( `${settings.apiBase}/get-taxonomies?post_type=${settings.postType}` )
            dispatch({ type: actions.SET_TAX_OPTIONS, payload: response });
        }

        fetchData().catch( console.error );
    }, [] );

    const value = {
        tax: state.tax,
        selectedTax: state.selectedTax,
        selectTaxTerm: (tax, term) => {
            dispatch({ type: actions.SELECT_TAX_TERM, payload: { 'tax': tax, 'term' : term } });
        },
        clearFilters: () => {
            dispatch({ type: actions.CLEAR_FILTERS });
        },
    }

    return (
        <FiltersContext.Provider value={ value }>
            {children}
        </FiltersContext.Provider>
    )
}

const useFiltersContext = () => React.useContext(FiltersContext)

export { FiltersProvider, useFiltersContext };